// Admin-only Danger Zone: full reset (opens the typed-confirmation pop-up).
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.

export default function DangerZone({ busy, me, openResetModal, refresh }) {
  return (
    <>
      {/* T1.2 — Admin Danger Zone: Full reset moved here, with typed
           confirmation and pre-wipe snapshot. */}
{me && me.isAdmin && (
      <div id="danger-zone" className="card" style={{ marginTop: '2rem', padding: '1rem', border: '1px dashed #b91c1c', background: '#fef2f2' }}>
        <h3 style={{ color: '#991b1b', marginTop: 0 }}>Admin — Danger Zone</h3>
        <p className="small" style={{ marginTop: 0, color: '#7f1d1d' }}>
          Full reset wipes both the Approved DB and the sheet inbox, then re-imports from the bundled historical seed and the Google Sheet.
          A timestamped snapshot of both tables is created in Supabase BEFORE the wipe begins.
          You must type <code>RESET</code> to enable the button.
        </p>
        <button className="refresh-btn" onClick={openResetModal} disabled={busy} style={{ background: '#b91c1c' }}>
          Full reset…
        </button>
      </div>
      )}
    </>
  );
}
